<template>

  <div>

    <b-modal
        v-model="showModalOccurrenceOldPhotos"
        title="Fotos de inspeções anteriores"
        size="xl"
        scrollable
        hide-footer
        @hidden="evidenceOldForeignKey = null">

      <h5>{{ evidenceOldDate | datetime }}</h5>
      <div>
        <b-icon icon="person" class="mr-1"></b-icon>
        {{ evidenceOldUser }}
      </div>

      <OccurrenceFile
          v-if="showModalOccurrenceOldPhotos"
          only-view type-image
          message-not-record="Nenhuma foto inserida"
          :checklist-id="evidenceOldChecklistId"
          :foreign-key="evidenceOldForeignKey"/>

    </b-modal>

    <t-dialog-form tabs large
                   :generalErrors="generalErrors" :title="title"
                   :hide-submit="checklistEnvironment.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED"
                   :ok-text="okText"
                   :id="id"
                   :command="localCommand"
                   :status="status"
                   :variant="variant"
                   :set-tab-index="tabIndex"
                   @show="showModal"
                   @hidden="onCloseItem"
                   ref="dialog_form" @onSubmit="onSubmit">

      <template #header-tab>

        <t-msg info v-if="checklistEnvironment.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED">
          Ambiente já finalizado para alterar dados ou imagens estorne a finalização da inspeção/ambiente ou modifique o
          <b-link v-if="objValid(occurrence)" :to="{path: '/checklist/occurrence/'+occurrence.occurrenceNumber}"
                  target="_blank">apontamento diretamente.
          </b-link>
          <span v-else>apontamento diretamente.</span>

        </t-msg>

      </template>

      <template #default>

        <t-form-tab title="Dados Básicos" class="border">

          <div v-show="dialogIsLoaded">

            <!--Se trocar v-show para v-if irá dar problema no campo de data-->
            <div v-if="objValid(occurrence)">

              <b-row
                  v-show="(form.statusItemOccurrence !== StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW || checklistEnvironment.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED) && occurrence !== null">

                <b-col cols="3">
                  <label>Cód. Apontamento</label>

                  <b-row>
                    <b-col cols="12">
                      <b-button
                          :to="{path: '/checklist/occurrence/'+occurrence.occurrenceNumber}"
                          size="sm"
                          variant="outline-primary" target="_blank">
                        <b-icon-box-arrow-up-right class="mr-2"/>
                        <span v-if="objValid(occurrence.otherCodeLabel)">{{ occurrence.otherCodeLabel }}</span>
                        <span v-else>{{ occurrence.occurrenceCodeLabel }}</span>

                      </b-button>


                    </b-col>
                  </b-row>


                </b-col>


                <t-input label="Data Abertura" cols="3" v-model="occurrence.occurrenceCreatedDate" datetime fixed/>

                <t-input label="Usuário" cols="3" v-model="occurrence.occurrenceCreatedUser" fixed/>

                <t-input label="Responsável" cols="3" v-model="occurrence.executor" fixed/>


              </b-row>

            </div>


            <b-row>

              <t-input label="Ambiente" cols="3" v-model="checklistEnvironment.environment" fixed/>

              <t-input label="Complemento do Ambiente"
                       help="Utilize caso desejar acrescentar para identificar o ambiente correto." cols="3"
                       v-model="form.environmentComplement"
                       :fixed="checklistEnvironment.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED"/>

              <b-col cols="3">

                <t-input v-model="form.deadline" date label="Prazo"/>


                <small
                    v-if="deadlineStatus"
                    :class="{
            'text-success': deadlineStatus.type === 'future',
            'text-warning': deadlineStatus.type === 'today',
            'text-danger': deadlineStatus.type === 'late'
          }"
                >
                  {{ deadlineStatus.text }}
                </small>

                <small v-if="deadlineStatus && objValid(form.deadlineOriginal)"> - </small>

                <small v-if="objValid(form.deadlineOriginal)">Original: {{ form.deadlineOriginal | date }}
                  <t-help title="Primeiro prazo cadastrado"/>
                </small>


              </b-col>


              <t-input label="Conclusão (%)"
                       cols="3"
                       range
                       v-model="form.conclusion"/>

            </b-row>


            <t-input label="Item" v-model="typeChecklistItem" fixed/>


            <!--
             Permitido alteração, desde que ambiente não esteja finalizado
  
             <div
                          v-if="form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW && checklistEnvironment.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED">         -->

            <div
                v-if="checklistEnvironment.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED">

              <b-row>

                <b-col cols="12">
                  <t-input v-model="form.description"
                           textarea max-length="1000"
                           enable-optimize-ai
                           label="Descrição técnica"
                  />
                </b-col>

                <b-col cols="8">

                  <div class="d-flex">

                    <div>Anomalia</div>

                    <b-form-checkbox class="ml-3" v-model="form.typePathologyNotFound" switch>

                      <small>Outra?</small>

                    </b-form-checkbox>

                  </div>

                  <t-input-code-label type-pathology
                                      :status="status"
                                      :command="command"
                                      @onResume="getResumeTypePathology"
                                      v-show="!form.typePathologyNotFound"
                                      hide-label
                                      :required="!form.typePathologyNotFound"
                                      v-model="form.typePathologyId"/>

                  <b-row v-show="form.typePathologyNotFound">
                    <t-input
                        cols="4"
                        v-model="form.sectorId"
                        label="Categoria"
                        hide-label
                        placeholder="Categoria"
                        :options="sectorOptions" select
                        :required="form.typePathologyNotFound"/>

                    <t-input
                        cols="8"
                        v-model="form.typePathologyNotFoundOther"
                        hide-label label="Anomalia - Outra" textarea max-length="500"
                        placeholder="Informe a anomalia desejada"
                        :required="form.typePathologyNotFound"/>
                  </b-row>

                </b-col>

                <b-col cols="4">

                  <label for="Ambiente">Criticidade *</label>

                  <b-radio-group stacked class="mb-2" id="" v-model="form.typeCriticalityId">

                    <b-radio v-for="criticality in typeCriticalityList" :key="criticality.typeCriticalityId"
                             :style="{'color':criticality.color !== undefined && criticality.color !== '' ? criticality.color : ''}"
                             :value="criticality.typeCriticalityId">
                      {{ criticality.name }}
                    </b-radio>

                  </b-radio-group>

                </b-col>

              </b-row>

              <b-row>

                <b-col cols="12">

                  <div class="d-flex">
                    <label>Origem *</label>
                    <t-help click modal-title="Origem da Anomalia">

                      <div class="help-box help-anomaly-origin">

                        <p>
                          Selecione a origem que melhor representa a causa prov&aacute;vel da anomalia observada.
                          Caso n&atilde;o seja poss&iacute;vel concluir no momento da inspe&ccedil;&atilde;o, utilize a
                          op&ccedil;&atilde;o
                          <strong>N&atilde;o determinada</strong>.
                        </p>

                        <ul>
                          <li class="mb-2">
                            <strong>End&oacute;gena</strong><br/>
                            Anomalia originada por falhas de projeto, execu&ccedil;&atilde;o, materiais ou sistemas
                            construtivos da pr&oacute;pria edifica&ccedil;&atilde;o.
                          </li>
                          <li class="mb-2">
                            <strong>Ex&oacute;gena</strong><br/>
                            Anomalia causada por agentes externos &agrave; edifica&ccedil;&atilde;o, como a&ccedil;&otilde;es
                            clim&aacute;ticas, ambientais, do entorno ou interfer&ecirc;ncias de terceiros.
                          </li>
                          <li class="mb-2">
                            <strong>Funcional / Uso</strong><br/>
                            Anomalia decorrente do uso inadequado, opera&ccedil;&atilde;o incorreta, sobrecarga ou falta
                            de manuten&ccedil;&atilde;o do sistema ou elemento inspecionado.
                          </li>
                          <li class="mb-2">
                            <strong>N&atilde;o determinada</strong> <em>(opção padrão)</em><br/>
                            Utilizada quando n&atilde;o &eacute; poss&iacute;vel definir com seguran&ccedil;a a origem
                            da
                            anomalia no momento da inspe&ccedil;&atilde;o.
                          </li>
                        </ul>

                        <div>Conforme o tipo de anomalia é possível parametrizar a origem provável, podendo ser revisada
                          manualmente para melhor escolha.
                        </div>

                      </div>


                    </t-help>
                  </div>

                  <t-input v-model="form.typeAnomalyOrigin" hide-label radio :options="AnomalyOriginType.list" required
                           label="Origem da Anomalia"/>


                </b-col>


              </b-row>


              <b-card-title class="border-bottom pb-2">Gerenciamento Risco</b-card-title>

              <b-row>

                <t-input select cols="3" label="Gravidade" v-model="form.typeSeverity"
                         :options="SeverityType.list"/>

                <t-input select cols="3" label="Urgência" v-model="form.typeUrgency"
                         :options="UrgencyType.list"/>

                <t-input select cols="3" label="Tendência" v-model="form.typeTrend"
                         :options="TrendType.list"/>

                <b-col cols="3">
                  <t-occurrence-risk :type-severity="form.typeSeverity" :type-urgency="form.typeUrgency"
                                     :type-trend="form.typeTrend"/>
                </b-col>


              </b-row>


              <div v-if="businessTypeSurvey === SurveyType.type.BUDGET">


                <b-card-title class="border-bottom pb-2 mt-2">Orçamento</b-card-title>

                <!--
                <b-form-checkbox v-model="form.budgetEnabled" class="mb-2" switch>
                  Adicionar Orçamento?
                </b-form-checkbox>
                -->

                <b-row v-if="form.budgetEnabled && userAccessBudgetShowPrice"
                       class="alert-success m-2 p-2 b-radius-small mb-2">

                  <t-input cols="3" decimals="2" number :required="form.budgetEnabled" v-model="form.budgetQuantity"
                           @change="onBudgetTotalPrice" label="Qtd."/>
                  <t-input cols="3" v-model="form.budgetUnit"
                           select first-default :options="UnitType.list"
                           label="Medida"/>

                  <t-input cols="3" v-model="form.budgetPrice" money @change="onBudgetTotalPrice"
                           label="Valor Un."/>

                  <t-input cols="3" v-model="budgetTotalPrice" highlight money fixed label="Valor Total"/>

                </b-row>

              </div>


            </div>


            <div v-else-if="occurrence !== null">

              <b-row>

                <t-input label="Descrição técnica" cols="4" v-model="occurrence.description" fixed/>

                <t-input label="Anomalia" cols="3" v-model="occurrence.typePathologyAutomatically" fixed/>

                <b-col cols="2">

                  <div>
                    Criticidade<br/>
                    <b-badge variant="danger"
                             v-if="occurrence.typeCriticalityDegree > 1 && occurrence.typeCriticalityLineClass === 'bg-danger-light'">
                      {{ occurrence.typeCriticality }}
                    </b-badge>
                    <b-badge variant="warning"
                             v-else-if="occurrence.typeCriticalityDegree > 1 && occurrence.typeCriticalityLineClass === 'bg-warning-light'">
                      {{ occurrence.typeCriticality }}
                    </b-badge>

                    <b-badge variant="info" v-else>{{ occurrence.typeCriticality }}</b-badge>

                  </div>

                </b-col>

                <b-col cols="3">
                  <div>
                    Sinalizada finalização
                    <t-help
                        title="Caso o executor tenha sinalizado que finalizou o apontamento, será informado por este campo."/>
                    <br/>
                    <b-badge variant="info" v-if="objValid(occurrence.executorSignaled)">Sinalizada em:
                      {{ occurrence.executorSignaled | datetime }}
                    </b-badge>
                    <b-badge v-else>Não sinalizada</b-badge>
                  </div>

                </b-col>

              </b-row>

              <b-row>

                <b-col cols="12">

                  <div class="d-flex">
                    <label>Origem *</label>
                    <t-help click modal-title="Origem da Anomalia">

                      <div class="help-box help-anomaly-origin">

                        <p>
                          Selecione a origem que melhor representa a causa prov&aacute;vel da anomalia observada.
                          Caso n&atilde;o seja poss&iacute;vel concluir no momento da inspe&ccedil;&atilde;o, utilize a
                          op&ccedil;&atilde;o
                          <strong>N&atilde;o determinada</strong>.
                        </p>

                        <ul>
                          <li class="mb-2">
                            <strong>End&oacute;gena</strong><br/>
                            Anomalia originada por falhas de projeto, execu&ccedil;&atilde;o, materiais ou sistemas
                            construtivos da pr&oacute;pria edifica&ccedil;&atilde;o.
                          </li>
                          <li class="mb-2">
                            <strong>Ex&oacute;gena</strong><br/>
                            Anomalia causada por agentes externos &agrave; edifica&ccedil;&atilde;o, como a&ccedil;&otilde;es
                            clim&aacute;ticas, ambientais, do entorno ou interfer&ecirc;ncias de terceiros.
                          </li>
                          <li class="mb-2">
                            <strong>Funcional / Uso</strong><br/>
                            Anomalia decorrente do uso inadequado, opera&ccedil;&atilde;o incorreta, sobrecarga ou falta
                            de manuten&ccedil;&atilde;o do sistema ou elemento inspecionado.
                          </li>
                          <li class="mb-2">
                            <strong>N&atilde;o determinada</strong> <em>(opção padrão)</em><br/>
                            Utilizada quando n&atilde;o &eacute; poss&iacute;vel definir com seguran&ccedil;a a origem
                            da
                            anomalia no momento da inspe&ccedil;&atilde;o.
                          </li>
                        </ul>

                        <div>Conforme o tipo de anomalia é possível parametrizar a origem provável, podendo ser revisada
                          manualmente para melhor escolha.
                        </div>

                      </div>


                    </t-help>
                  </div>

                  <t-input v-model="form.typeAnomalyOrigin" hide-label radio :options="AnomalyOriginType.list" required
                           label="Origem da Anomalia"/>


                </b-col>


              </b-row>

              <b-card-title class="border-bottom pb-2">Gerenciamento Risco</b-card-title>

              <b-row>

                <t-input select cols="3" label="Gravidade" v-model="form.typeSeverity"
                         :options="SeverityType.list"/>

                <t-input select cols="3" label="Urgência" v-model="form.typeUrgency"
                         :options="UrgencyType.list"/>

                <t-input select cols="3" label="Tendência" v-model="form.typeTrend"
                         :options="TrendType.list"/>

                <b-col cols="3">
                  <t-occurrence-risk :type-severity="form.typeSeverity" :type-urgency="form.typeUrgency"
                                     :type-trend="form.typeTrend"/>
                </b-col>


              </b-row>


              <div v-if="businessTypeSurvey === SurveyType.type.BUDGET && occurrence.budgetEnabled">

                <b-card-title class="border-bottom pb-2 mt-2">Orçamento</b-card-title>

                <b-row v-if="form.budgetEnabled" class="alert-success m-2 p-2 b-radius-small mb-2">

                  <t-input cols="3" decimals="2" number :required="form.budgetEnabled"
                           v-model="form.budgetQuantity"
                           @change="onBudgetTotalPrice" label="Qtd."/>
                  <t-input cols="3" v-model="form.budgetUnit"
                           select first-default :options="UnitType.list"
                           label="Medida"/>
                  <t-input cols="3" v-model="form.budgetPrice" decimals="2" number @change="onBudgetTotalPrice"
                           label="Valor Un."/>
                  <t-input cols="3" v-model="budgetTotalPrice" highlight money fixed label="Valor Total"/>

                </b-row>

              </div>

            </div>


            <b-row>

              <b-col cols="12">


                <t-msg info v-if="regulationList.length === 0" style="display: none">Nenhuma norma técnica cadastrada
                  para
                  possibilitar o
                  vinculo com apontamentos. Caso desejar cadastre através do menu 'Inspeções' > 'Configurações' <a
                      href="/checklist/regulation" target="_blank">'Normas Técnicas'</a></t-msg>

                <div v-else class="mb-3">

                  <t-button v-if="!showRegulation && form.regulations.length === 0" @click="showRegulation = true"
                            small>
                    <b-icon-bookmark-check class="mr-2"/>
                    Aplicar Normas Técnicas
                  </t-button>

                  <div v-if="showRegulation || form.regulations.length > 0">


                    <b-card-title class="border-bottom pb-2 mt-2">Normas Técnicas</b-card-title>

                    <t-table

                        enable-checked
                        v-model="form.regulations"
                        :items="regulationList"
                        :fields="viewFieldsRegulation"
                        title-items="normas"
                        link-primary-column="title"
                        table-bordered
                        disable-actions-column
                        primary-key-column="regulationId">

                      <template #first-column="{item}">

                  <span
                      class="badge badge-light"
                      :style="{'background-color': item.typeRegulationBackgroundColor,'color': item.typeRegulationTextColor}">{{
                      item.name
                    }}</span>
                        <br/>
                        {{ item.title }}
                        <t-help :title="item.description"></t-help>


                      </template>

                    </t-table>

                  </div>


                </div>

              </b-col>

            </b-row>

            <b-row class="border-top mt-2 pt-3 d-flex align-content-end justify-content-end"
                   v-if="form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING && checklistEnvironment.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED">

              <div>
                <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="finishPending" @change="onFinishPending" switch>
                  <b style="font-size: 15px">Finalizar apontamento?</b>
                  <t-help
                      title="Você poderá escolher entre manter pendente ou finalizar o apontamento."/>
                </b-form-checkbox>
              </div>

            </b-row>


            <b-row class="border-top mt-2 pt-3 d-flex align-content-end justify-content-end"
                   v-if="form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW && checklistEnvironment.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED">

              <div>
                <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.finishAfterOpening" switch>
                  <b style="font-size: 15px">Finalizar após abertura?</b>
                  <t-help click modal-title="Finalização Após Abertura"
                          title="Utilize esta opção para abrir e finalizar o apontamento em uma única etapa.<br />
                          Esse recurso é utilizado quando é necessário registrar o apontamento, mesmo que a atividade já tenha sido concluída no momento do registro.<br /><br />
                          O apontamento será contabilizado uma única vez em 'Finalizados', caso houver mais que uma foto, a última será considera como foto de finalização."/>
                </b-form-checkbox>

              </div>

            </b-row>

            <!--
            Não implementado por isso não informado
            <t-msg info v-if="form.finishAfterOpening"><b>Finalizar após abertura – regras de imagens:</b>
              <ul>
                <li><b>1 imagem:</b> considerada como <b>imagem de abertura</b>.</li>
                <li><b>2 ou mais imagens:</b> a <b>última</b> será considerada como <b>imagem de finalização</b>.</li>
              </ul>
              Obs.: Recomendamos sempre incluir <b>ao menos uma imagem adicional</b> para registro da finalização.
            </t-msg>
            -->

          </div>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Fotos" lazy class="border">

          <div>

            <t-form-card title="Novas" class="border">


              <ChecklistOccurrenceFile
                  message-not-record="Nenhuma foto inserida"
                  :only-view="localCommand === 'view' || localCommand === 'delete'"
                  type-image
                  :foreign-key="form.checklistItemOccurrenceId"/>

              <t-msg warning
                     v-if="checklistEnvironment.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED && objValid(occurrence)">
                As imagens apresentadas pertencem a esta inspeção e refletem o período em que ela foi realizada. Para
                visualizar fotos atualizadas, consulte o apontamento.
              </t-msg>

            </t-form-card>

            <t-form-card title="Anteriores" class="border"
                         v-if="form.statusItemOccurrence !== StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW">

              <t-button light small @click="getOccurrenceOldChecklistFiles()" class="mb-2">
                <b-icon-eye v-show="!showOccurrenceOldPhotos" class="mr-2"/>
                <b-icon-eye-slash v-show="showOccurrenceOldPhotos" class="mr-2"/>
                <span v-show="!showOccurrenceOldPhotos">Exibir</span>
                <span v-show="showOccurrenceOldPhotos">Ocultar</span>
              </t-button>

              <t-msg info v-show="!showOccurrenceOldPhotos">Imagens de outras inspeções realizadas neste mesmo
                apontamento
              </t-msg>

              <div class="d-flex align-items-center flex-wrap mb-2" v-if="showOccurrenceOldPhotos">

                <!-- ANO (dinâmico) -->
                <div class="mr-3 mb-2">
                  <small class="text-muted d-block mb-1">Ano</small>

                  <b-button
                      v-for="y in occurrenceYears"
                      :key="'y'+y"
                      size="sm"
                      class="mr-1"
                      :variant="filterYear === y ? 'primary' : 'outline-secondary'"
                      @click="toggleYear(y)"
                  >
                    <b-icon icon="calendar3" class="mr-1"></b-icon>
                    {{ y }}
                  </b-button>
                </div>

                <!-- PERÍODO -->
                <div class="mr-3 mb-2">
                  <small class="text-muted d-block mb-1">Período</small>

                  <b-button
                      v-for="d in [30,60,90]"
                      :key="'d'+d"
                      size="sm"
                      class="mr-1"
                      :variant="filterDays === d ? 'primary' : 'outline-secondary'"
                      @click="toggleDays(d)"
                  >
                    <b-icon icon="clock-history" class="mr-1"></b-icon>
                    {{ d }} dias
                  </b-button>
                </div>

                <!-- LIMPAR -->
                <div class="mb-2">
                  <small class="text-muted d-block mb-1">&nbsp;</small>

                  <b-button
                      v-if="filterYear || filterDays"
                      size="sm"
                      variant="outline-danger"
                      @click="clearFilters"
                  >
                    <b-icon icon="x-circle" class="mr-1"></b-icon>
                    Limpar
                  </b-button>
                </div>

              </div>


              <b-list-group flush v-if="showOccurrenceOldPhotos">
                <b-list-group-item
                    v-for="(item, index) in occurrenceChecklistOldItemsFiltered"
                    :key="index"
                    button
                    class="evidence-item evidence-grid card-hover-shadow hover table-hover"
                    @click="openOccurrenceOld(item)"
                    :title="'Abrir fotos desta inspeção'"
                >
                  <!-- COL 1: Data -->
                  <div class="evidence-col-date">
                    <b-icon icon="clock-history" class="text-muted mr-2"></b-icon>
                    <span class="evidence-date">
        {{ item.logControl.createdDate | datetime }}
      </span>
                  </div>

                  <!-- COL 2: Spacer (respiro visual) -->
                  <div></div>

                  <!-- COL 3: Qtd Fotos -->
                  <div class="evidence-col-photos">
      <span class="badge evidence-badge border">
        <b-icon icon="camera" class="mr-1"></b-icon>
        {{ item.qtyPhotos }}
      </span>
                  </div>

                  <!-- COL 4: Responsável -->
                  <div class="evidence-col-user">
                    <small class="text-muted text-truncate">
                      <b-icon icon="person" class="mr-1"></b-icon>
                      {{ item.logControl.createdUser }}
                    </small>
                  </div>
                </b-list-group-item>
              </b-list-group>

              <small class="text-muted pt-2" v-if="showOccurrenceOldPhotos">
                Exibindo {{ occurrenceChecklistOldItemsFiltered.length }} de {{ occurrenceChecklistOldItems.length }}
              </small>

            </t-form-card>

          </div>


        </t-form-tab>

        <t-form-tab title="Comentários" lazy class="border">


          <t-input textarea
                   :fixed="checklistEnvironment.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED"
                   label="Comentário" rows="3" @focusout="updateOccurrence('Comentário')"
                   v-model="form.comment"></t-input>


          <div class="mt-3" v-if="form.statusItemOccurrence !== StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW">

            Histórico de Comentários

            <b-list-group class="mb-4" v-if="form.historyComments.length > 1">

              <b-list-group-item v-for="comment in form.historyComments" :key="comment.commentId">

                <div>

                  <h5>{{ comment.resume }}</h5>

                </div>

                <div class="d-flex">

                  <div class="mr-2">
                    <small class="opacity-6">
                      <i class="fa fa-circle mr-1"></i>
                      <span
                          v-if="comment.logControl.updatedDate !== undefined && comment.logControl.updatedDate !== null"> {{
                          comment.logControl.updatedUser
                        }}</span>
                      <span v-else> {{ comment.logControl.createdUser }}</span>
                    </small>
                  </div>

                  <div class="mr-2">
                    <small class="opacity-6">
                      <i class="fa fa-calendar-alt mr-1"></i>
                      <span
                          v-if="comment.logControl.updatedDate !== undefined && comment.logControl.updatedDate !== null"> {{
                          comment.logControl.updatedDate | datetime
                        }}</span>
                      <span v-else> {{ comment.logControl.createdDate | datetime }}</span>
                    </small>
                  </div>

                </div>

              </b-list-group-item>

            </b-list-group>

            <t-msg warning v-else>Nenhum comentário anterior inserido</t-msg>

          </div>

        </t-form-tab>

      </template>

    </t-dialog-form>

  </div>


</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";
import StatusChecklistOccurrenceItemType from "@/model/types/modules/checklist/StatusChecklistOccurrenceItemType";
import ChecklistOccurrenceFile from "@/views/modules/checklist/Checklist/ChecklistOccurrenceFile";
import OccurrenceFile from "@/views/modules/checklist/OccurrenceFile";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import TypeCriticalityService from "@/services/modules/checklist/TypeCriticality.service";
import StatusChecklistEnvironmentType from "@/model/types/modules/checklist/StatusChecklistEnvironmentType";
import SectorService from "@/services/modules/agent/Sector.service";
import RegulationService from "@/services/modules/checklist/Regulation.service";
import UnitType from "@/model/types/modules/general/UnitType";
import SurveyType from "@/model/types/modules/checklist/SurveyType";
import SeverityType from "@/model/types/modules/checklist/SeverityType";
import TrendType from "@/model/types/modules/checklist/TrendType";
import UrgencyType from "@/model/types/modules/checklist/UrgencyType";
import tOccurrenceRisk from "@/components/template/form/input/t-occurrence-risk.vue";
import AnomalyOriginType from "@/model/types/modules/checklist/AnomalyOriginType";

export default {
  name: "ChecklistEnvironmentOccurrenceDialog",
  components: {tOccurrenceRisk, tDialogForm, ChecklistOccurrenceFile, OccurrenceFile},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      AnomalyOriginType,
      SeverityType,
      TrendType,
      UrgencyType,
      SurveyType,
      UnitType,
      StatusChecklistOccurrenceItemType,
      StatusChecklistEnvironmentType,
      id: "modal-checklist-item-occurrence",
      title: "",
      okText: "",
      path: "checklist/item/occurrence",
      localCommand: 'insert',
      form: {
        checklistItemOccurrenceId: 0,
        checklistItemId: 0,
        typeCriticalityId: 0,
        sectorId: 0, //Utilizado somente quando typePathologyNotFound = true
        typePathologyId: 0,
        typePathologyNotFound: false,
        typePathologyNotFoundOther: "",
        statusItemOccurrence: StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW,
        comment: "",
        description: "",
        positionX: 0,
        positionY: 0,
        positionScale: 0.0,
        positionRotation: 0,
        environmentComplement: "",
        deadline: "",
        budgetEnabled: false,
        budgetPrice: 0,
        budgetQuantity: 0,
        budgetUnit: "m",
        conclusion: 0,
        typeSeverity: 0,
        typeTrend: 0,
        typeUrgency: 0,
        volumetryQuantity: 0,
        volumetryUnit: "",
        status: 1,
        historyComments: [],
        regulations: [],
        typeAnomalyOrigin: 0,
        finishAfterOpening: false,
      },
      statusItemIntent: StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW, /*Armazena o status do item de intenção*/
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      showRegulation: false,
      regulationList: [],
      viewFieldsRegulation: [
        {key: "title", label: "Norma Técnica"},
        {key: "typeRegulation", label: "Categoria"},
      ],
      sectorOptions: [],
      typeCriticalityList: [],
      typeCriticalityId: 0, /*Opção padrão*/
      variant: "primary",
      tabIndex: 0,
      checklistEnvironment: {},
      checklistItem: {},
      budgetTotalPrice: 0,
      finishPending: false,
      showOccurrenceOldPhotos: false,
      showModalOccurrenceOldPhotos: false,
      evidenceOldForeignKey: 0,
      evidenceOldChecklistId: 0,
      evidenceOldDate: null,
      evidenceOldUser: null,
      occurrenceChecklistOldItems: [],
      filterYear: null,       // ex: 2026
      filterDays: null,        // ex: 30, 60, 90
    }

  },
  props: {
    userAccessBudgetShowPrice: {
      type: Boolean,
      default: false,
    },
    checklistEnvironmentId: Number,
    enterpriseId: Number,
    occurrence: {},
    businessTypeSurvey: Number,
    typeChecklistItem: String,
    checklistItemId: Number,
    setTabIndex: {
      type: Number,
      default: 0,
    },
    onlyView: Boolean,
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.dialogIsLoaded = false

      this.resetModal()

      //Busca os dados do ambiente
      await http.get('checklist/environment/' + this.checklistEnvironmentId).then(response => {
        this.checklistEnvironment = response.data
      }).catch(error => ui.generalResponseError(this, error))


      //Busca os dados do item
      await http.get('checklist/item/' + this.checklistItemId).then(response => {
        this.checklistItem = response.data
      }).catch(error => ui.generalResponseError(this, error))

      this.form.checklistItemId = this.checklistItemId
      this.form.statusItemOccurrence = StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW
      this.form.status = 1


      if (this.businessTypeSurvey === SurveyType.type.BUDGET) {
        this.form.budgetEnabled = true
      }

      //Especificação da unidade de medida pelo item, caso a anomalia possuir outra terá prioridade na sobreposição mesmo que já contenha uma unidade de medida (modificações).
      if (this.checklistItem.unit !== '' && this.form.budgetEnabled && this.form.budgetUnit === '') {
        this.form.budgetUnit = this.checklistItem.unit
      }

      if (this.objValid(this.occurrence) && this.objValid(this.occurrence.checklistItemOccurrenceId))
        this.form.checklistItemOccurrenceId = this.occurrence.checklistItemOccurrenceId

      if (this.form.checklistItemOccurrenceId > 0) {

        if (this.onlyView) {
          this.localCommand = 'view'
        } else {
          this.localCommand = 'update'
        }

        await http.get(this.path + '/' + this.form.checklistItemOccurrenceId).then(response => {

          this.form = response.data

          if (this.form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING) {
            //Marca para finalizar, porém somente irá alterar se enviar o submit
            this.statusItemIntent = StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE
          } else if (this.form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE) {
            //Marca para voltar para pendente, porém somente irá alterar se enviar o submit
            this.statusItemIntent = StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING
          }

          //Volta para aba inicial por padrão
          this.tabIndex = this.setTabIndex

        }).catch(error => ui.generalResponseError(this, error))

      } else {
        //Ações para inclusão

        //Valor padrão
        this.form.typeCriticalityId = this.typeCriticalityId

        await crudGeneral.get(this.path + "/createId").then(
            response => {
              this.form.checklistItemOccurrenceId = response.data.id
            }
        ).catch(error => this.responseError(error))


      }

      if (this.form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW) {

        this.title = this.typeChecklistItem + ' (Novo Apontamento)'
        this.okText = 'Incluir Apontamento'

        if (this.objValid(this.checklistItem.defaultTypePathologyId)) {
          if (this.checklistItem.defaultTypePathologyId > 0 && this.form.typePathologyId === 0)
            this.form.typePathologyId = this.checklistItem.defaultTypePathologyId //Seta anomalia padrão na inclusão somente se existir e não houver nenhuma selecionada.
        }
        this.variant = 'primary'

      } else if (this.form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING) {
        this.title = this.typeChecklistItem + ' - #' + this.form.occurrenceCodeLabel
        this.okText = 'Salvar Apontamento e manter pendente'
        this.variant = 'warning'
      } else if (this.form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE) {
        this.title = this.typeChecklistItem + ' - #: ' + this.form.occurrenceCodeLabel
        this.okText = 'Estornar Finalização'
        this.variant = 'danger'
      }


      if (this.checklistEnvironment.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED) {
        this.localCommand = 'view'
      }


      await this.onBudgetTotalPrice()

      this.dialogIsLoaded = true

    },

    async getResumeTypePathology(resume) {

      //Poderá sobrepor desde que não tenha valor já informado ou a unidade tenha sido preenchida pelo item
      if (this.form.typePathologyId > 0 && this.form.budgetEnabled && resume.unit !== '' && (this.form.budgetUnit === '' || this.form.budgetUnit === this.checklistItem.unit)) {
        this.form.budgetUnit = resume.unit
      }

      if (this.form.typeAnomalyOrigin === 0) {
        //Não há opção escolhida

        if (this.objValid(resume.defaultTypeAnomalyOrigin) && resume.defaultTypeAnomalyOrigin > 0) {
          //Opção de acordo com tipo de Anomalia
          this.form.typeAnomalyOrigin = resume.defaultTypeAnomalyOrigin
        } else {
          //Opção padrão geral
          this.form.typeAnomalyOrigin = AnomalyOriginType.type.UNDETERMINED
        }

      }


    },

    onFinishPending(val) {

      if (val) {
        this.okText = 'Finalizar Apontamento'
        this.variant = 'success'
      } else {
        this.okText = 'Salvar Apontamento e manter pendente'
        this.variant = 'warning'
      }

    },


    onBudgetTotalPrice() {

      if (this.form.budgetPrice > 0 && this.form.budgetQuantity > 0) {
        this.budgetTotalPrice = this.form.budgetPrice * this.form.budgetQuantity
      } else {
        this.budgetTotalPrice = 0
      }

    },

    onCloseItem() {

      this.resetModal()
      this.$emit("onClose", false)

    },

    async updateOccurrence(origin) {

      if (this.form.statusItemOccurrence !== StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW && this.localCommand !== 'view') {
        //Atualiza o comentário mesmo sem gravar
        await http.put(this.path, this.form).then(() =>
            ui.toast(this, 'Sucesso', origin + ' atualizado com sucesso!')
        ).catch(error => this.responseError(error));

      }

    },

    async getOccurrenceOldChecklistFiles() {

      this.showOccurrenceOldPhotos = !this.showOccurrenceOldPhotos

      if (this.showOccurrenceOldPhotos) {

        await http.get('checklist/item/occurrence/getAllToFileOld/' + this.checklistEnvironment.checklistId + '/' + this.occurrence.occurrenceId).then(async response => {

          this.occurrenceChecklistOldItems = response.data

        }).catch(error => ui.generalResponseError(this, error))

      }

    },

    openOccurrenceOld(item) {
      this.evidenceOldForeignKey = item.occurrenceId
      this.evidenceOldChecklistId = item.checklistId
      this.evidenceOldDate = item.logControl.createdDate
      this.evidenceOldUser = item.logControl.createdUser
      this.showModalOccurrenceOldPhotos = true
    },

    getYearUTC(dateValue) {
      if (!dateValue) return null
      const d = new Date(dateValue)
      if (isNaN(d.getTime())) return null
      return d.getUTCFullYear()
    },

    diffDaysUTC(dateValue) {
      if (!dateValue) return null
      const d = new Date(dateValue)
      if (isNaN(d.getTime())) return null

      const now = new Date()

      // zera em UTC para comparação consistente
      const start = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
      const end = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())

      return Math.floor((end - start) / (1000 * 60 * 60 * 24))
    },

    toggleYear(y) {
      // se clicar no mesmo ano, desmarca
      if (this.filterYear === y) {
        this.filterYear = null
        return
      }

      // selecionou um ano => limpa período
      this.filterYear = y
      this.filterDays = null
    },

    toggleDays(d) {
      // se clicar no mesmo período, desmarca
      if (this.filterDays === d) {
        this.filterDays = null
        return
      }

      // selecionou um período => limpa ano
      this.filterDays = d
      this.filterYear = null
    },

    clearFilters() {
      this.filterYear = null
      this.filterDays = null
    },

    async onSubmit() {

      if ((this.form.typeSeverity > 0 || this.form.typeUrgency > 0 || this.form.typeTrend > 0) && (this.form.typeSeverity === 0 || this.form.typeUrgency === 0 || this.form.typeTrend === 0)) {
        ui.msgError(this, 'Você preencheu um dos campos da matriz de risco GUT, porém não preencheu os demais, neste caso é permitido deixar todos em branco ou preencher todos para que o cálculo seja correto.')
      } else {


        /*Comando são iguais devido chave temporária*/
        if (this.localCommand === 'insert' || this.localCommand === 'update') {

          this.status = "sending"

          const statusItemOccurrenceOld = this.form.statusItemOccurrence

          //Marca o statusItem alvo do submit
          this.form.statusItemOccurrence = this.statusItemIntent

          if (this.form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW && this.form.conclusion === 100) {
            ui.msgError(this, 'Não é possível inserir um apontamento novo com conclusão de 100%.')
          }

          if (this.form.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING && this.form.conclusion === 100) {

            //Deverá finalizar o apontamento, pois foi informado 100%
            this.statusItemIntent = StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE
            this.form.statusItemOccurrence = StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE

          }

          if (statusItemOccurrenceOld === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING && !this.finishPending) {
            //Usuário não deseja finalizar o apontamento, apenas salvar
            this.statusItemIntent = StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING
            this.form.statusItemOccurrence = StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING
          }

          await http.put(this.path, this.form).then(response => {
            this.itemInserted = response.data
            this.$emit("onClose", true)
            this.successInsert()
          }).catch(error => this.responseError(error));

        }

      }

    },
  },
  async mounted() {

    await TypeCriticalityService.getAllCriticality().then((list) => {
      this.typeCriticalityList = list

      //Armazena o tipo padrão
      if (this.typeCriticalityList.length > 0)
        this.typeCriticalityId = this.typeCriticalityList[0].typeCriticalityId

    }).catch(error => this.responseError(error))

    await SectorService.selectList().then((list) => {
      this.sectorOptions = list
    }).catch(error => this.responseError(error))

    await RegulationService.selectAll().then((list) => {
      this.regulationList = list
    }).catch(error => this.responseError(error))


  },

  computed: {
    deadlineStatus() {
      if (!this.objValid(this.form.deadline)) {
        return null
      }

      const today = new Date()
      const diff = ui.dateDiff(today, this.form.deadline)

      if (diff > 0) {
        return {
          type: 'future',
          text: `Faltam ${diff} dia(s)`
        }
      }

      if (diff === 0) {
        return {
          type: 'today',
          text: 'Vence hoje'
        }
      }

      return {
        type: 'late',
        text: `Atrasado há ${Math.abs(diff)} dia(s)`
      }
    },

    occurrenceYears() {
      const years = {}
      for (const item of (this.occurrenceChecklistOldItems || [])) {
        const y = this.getYearUTC(item.logControl && item.logControl.createdDate)
        if (y) years[y] = true
      }
      // desc (2026, 2025, 2024...)
      return Object.keys(years).map(n => parseInt(n, 10)).sort((a, b) => b - a)
    },

    occurrenceChecklistOldItemsFiltered() {
      const list = (this.occurrenceChecklistOldItems || [])

      return list.filter((item) => {
        const created = item.logControl && item.logControl.createdDate

        // filtro por ano
        if (this.filterYear) {
          const y = this.getYearUTC(created)
          if (y !== this.filterYear) return false
        }

        // filtro por dias
        if (this.filterDays) {
          const days = this.diffDaysUTC(created)
          if (days == null) return false
          if (days > this.filterDays) return false
        }

        return true
      })
    }

  },

  watch: {
    setTabIndex(value) {
      this.tabIndex = value
    },
  }
}
</script>
